import { Fragment } from "react";

export interface InlineSegment {
  text: string;
  bold: boolean;
}

const BOLD_PATTERN = /\*\*(.+?)\*\*/g;

/** Splits on `**bold**` only; any other markdown, and an unpaired `**`, stays literal. */
export const parseInlineBold = (text: string): InlineSegment[] => {
  const segments: InlineSegment[] = [];
  let cursor = 0;
  for (const match of text.matchAll(BOLD_PATTERN)) {
    const start = match.index ?? 0;
    if (start > cursor) {
      segments.push({ text: text.slice(cursor, start), bold: false });
    }
    segments.push({ text: match[1], bold: true });
    cursor = start + match[0].length;
  }
  if (cursor < text.length) {
    segments.push({ text: text.slice(cursor), bold: false });
  }
  return segments;
};

export const InlineBoldText: React.FC<{ text: string }> = ({ text }) => (
  <>
    {parseInlineBold(text).map((segment, index) =>
      segment.bold ? (
        <span key={index} className="font-semibold">
          {segment.text}
        </span>
      ) : (
        <Fragment key={index}>{segment.text}</Fragment>
      ),
    )}
  </>
);
